import { React, useState, useEffect ,useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form from "../../component/utilities/Forms";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import * as CONST from "../../component/config/Constant";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

export default function Register() {
  const navigate = useNavigate();


  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [roleId, setRoleId] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);


  const [validate, setValidate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  // Fetch roles and departments on component mount
  useEffect(() => {
    fetchRoles();
    fetchDepartments();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await axios.get(CONST.GET_ROLES);
      if (response.data.result && Array.isArray(response.data.result)) {
        setRoles(response.data.result);
      } else if (response.data.data && Array.isArray(response.data.data)) {
        setRoles(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to load roles");
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await axios.get(CONST.GET_DEPARTMENTS);
      if (response.data.result && Array.isArray(response.data.result)) {
        setDepartments(response.data.result);
      } else if (response.data.data && Array.isArray(response.data.data)) {
        setDepartments(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      toast.error("Failed to load departments");
    }
  };

  // Handle profile image upload
  const handleImageChange = (e) => {
  const file = e.target.files[0];
  if (!file) return;

 //allwoed types of images
  const allowedTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
  ];

  if (!allowedTypes.includes(file.type)) {
    toast.error("Only JPG, JPEG, PNG or WEBP images are allowed");
    e.target.value = ""; // reset file input
    return;
  }

  if (file.size > 5 * 1024 * 1024) {
    toast.error("Image size must be less than 5MB");
    e.target.value = "";
    return;
  }

  setProfilePhoto(file);

  const reader = new FileReader();
  reader.onloadend = () => {
    setPreviewImage(reader.result);
  };
  reader.readAsDataURL(file);
};


  // Validate form
  const validateRegister = async () => {
    let isValid = true;
    let validator = Form.validator({
      firstName: {
        value: firstName,
        isRequired: true,
        label: "first name",
      },
      lastName: {
        value: lastName,
        isRequired: true,
        label: "last name",
      },
      email: {
        value: email,
        isRequired: true,
        isEmail: true,
        label: "email",
      },
      password: {
        value: password,
        isRequired: true,
        minLength: 6,
        label: "password",
      },
      confirmPassword: {
        value: confirmPassword,
        isRequired: true,
        minLength: 6,
        label: "confirm password",
      },
      roleId: {
        value: roleId,
        isRequired: true,
        label: "role",
      },
      departmentId: {
        value: departmentId,
        isRequired: true,
        label: "department",
      },
    });

    if (validator !== null) {
      setValidate({
        validate: validator.errors,
      });
      isValid = false;
    } else if (password !== confirmPassword) {
      setValidate({
        validate: { confirmPassword: ["Passwords do not match"] },
      });
      isValid = false;
    } else {
      isValid = true;
      setValidate({});
    }

    return isValid;
  };

  // Handle form submission
  const handleRegister = async (e) => {
    e.preventDefault();

    const isValid = await validateRegister();

    if (isValid) {
      setLoading(true);

    //File Upload
      const formData = new FormData();
      formData.append("first_name", firstName);
      formData.append("last_name", lastName);
      formData.append("email", email);
      formData.append("password", password);
      formData.append("confirm_password", confirmPassword);
      formData.append("role_id", roleId);
      formData.append("department_id", departmentId);

      if (profilePhoto) {
        console.log("Profile Photo Details:", {
          name: profilePhoto.name,
          size: profilePhoto.size,
          type: profilePhoto.type,
          lastModified: profilePhoto.lastModified,
        });
        formData.append("profile_photo", profilePhoto);
      }

      // Log FormData contents
      console.log("FormData contents:");
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`  ${key}: File(${value.name}, ${value.size} bytes)`);
        } else {
          console.log(`  ${key}: ${value}`);
        }
      }

      try {
  const response = await axios.post(
    CONST.EMP_CREATE,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  setLoading(false);

  console.log("API Response:", response.data);

  if (response.data?.status === "success" || response.data?.status === "ok") {
    toast.success(response.data?.message || "Account created successfully!");

    // Reset form
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setRoleId("");
    setDepartmentId("");
    setProfilePhoto(null);
    setPreviewImage(null);

    
    setTimeout(() => {
      navigate("/login");
    }, 1500);

    return; 
  }

  if (response.data?.errors && Array.isArray(response.data.errors)) {
    toast.error(response.data.errors[0]);
    return;
  }

  if (response.data?.message) {
    toast.error(response.data.message);
    return;
  }

  toast.error("Unable to create account. Please try again.");

} catch (error) {
  setLoading(false);

  console.error("Registration error:", error);

  const backendMessage =
    error.response?.data?.message ||
    error.response?.data?.errors?.[0];

  toast.error(
    backendMessage || "Server error. Please try again later."
  );
}
    }
  };

  return (
    <>
      <Loading
        loading={loading}
        background="rgba(0, 0, 0, 0.5)"
        loaderColor="#fff"
      />
     <section
  className="page page-center login_forgot background_white"
  style={{ minHeight: "100vh", paddingBottom: "100px" }}
>
  <img
    src="/eportal/assets/img/hero/hero-1/shape-1.svg"
    alt=""
    className="shape shape-1"
  />

  <div className="container container-normal py-5">
    <div className="row align-items-center g-4 d-flex justify-content-center">
      <div className="col-lg-6">
        <h3 className="h3 mb-4">Create an account</h3>
        <p className="text-muted mb-3">
          Create an account free and enjoy it
        </p>

        <form
          className="auth-form"
          method="POST"
          onSubmit={handleRegister}
          autoComplete="off"
          
        >

          <div className="mb-3">
            <label className="form-label">
              Upload Profile Picture
            </label>

            <div className="d-flex align-items-center gap-3">
              <div className="profile-preview">
                {previewImage ? (
                  <img
                    src={previewImage}
                    alt="Profile preview"
                    className="rounded"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div
                    className="bg-light rounded d-flex align-items-center justify-content-center"
                    style={{ width: "100px", height: "100px" }}
                  >
                    <span className="text-muted text-center">
                      <i className="fa fa-image fa-2x"></i>
                      <p className="small">No image</p>
                    </span>
                  </div>
                )}
              </div>

              <input
                type="file"
                className="form-control"
                id="profilePhoto"
                accept="image/jpeg,image/jpg,image/png,image/webp"
                onChange={handleImageChange}
              />

            </div>
          </div>

          {/* First Name */}
          <div className="mb-3">
            <label className="form-label">
              First Name <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`form-control ${
                validate.validate?.firstName ? "is-invalid" : ""
              }`}
              value={firstName}
              placeholder="Enter your first name"
              onChange={(e) => setFirstName(e.target.value)}
            />

            <div className={`invalid-feedback ${validate.validate?.firstName ? "d-block" : ""}`}>
              {validate.validate?.firstName?.[0]}
            </div>
          </div>

          {/* Last Name */}
          <div className="mb-3">
            <label className="form-label">
              Last Name <span className="required">*</span>
            </label>

            <input
              type="text"
              className={`form-control ${
                validate.validate?.lastName ? "is-invalid" : ""
              }`}
              value={lastName}
              placeholder="Enter your last name"
              onChange={(e) => setLastName(e.target.value)}
            />

            <div className={`invalid-feedback ${validate.validate?.lastName ? "d-block" : ""}`}>
              {validate.validate?.lastName?.[0]}
            </div>
          </div>

          {/* Email */}
          <div className="mb-3">
            <label className="form-label">
              Email Address <span className="required">*</span>
            </label>

            <input
              type="email"
              className={`form-control ${
                validate.validate?.email ? "is-invalid" : ""
              }`}
              value={email}
              placeholder="your@email.com"
              onChange={(e) => setEmail(e.target.value)}
            />

            <div className={`invalid-feedback ${validate.validate?.email ? "d-block" : ""}`}>
              {validate.validate?.email?.[0]}
            </div>
          </div>

          {/* Password */}
          <div className="mb-3">
            <label className="form-label">
              Password <span className="required">*</span>
            </label>

            <div className="input-group input-group-flat">
              <input
                type={showPassword ? "text" : "password"}
                className={`form-control ${
                  validate.validate?.password ? "is-invalid" : ""
                }`}
                value={password}
                placeholder="Enter your password"
                onChange={(e) => setPassword(e.target.value)}
              />

              <span
  className="input-group-text cursor-pointer"
  onClick={() => setShowPassword(!showPassword)}
  style={{ background: "transparent", border: "none" }}
>
  <span
  className="input-group-text"
  onClick={() => setShowPassword(!showPassword)}
  style={{ cursor: "pointer" }}
>
  {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
</span>

</span >
            </div>

            <div className={`invalid-feedback d-block ${validate.validate?.password ? "" : "d-none"}`}>
              {validate.validate?.password?.[0]}
            </div>
          </div>

          {/* Confirm Password */}
          <div className="mb-3">
            <label className="form-label">
              Confirm Password <span className="required">*</span>
            </label>

            <input
              type={showConfirmPassword ? "text" : "password"}
              className={`form-control ${
                validate.validate?.confirmPassword ? "is-invalid" : ""
              }`}
              value={confirmPassword}
              placeholder="Confirm your password"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <div className={`invalid-feedback d-block ${validate.validate?.confirmPassword ? "" : "d-none"}`}>
              {validate.validate?.confirmPassword?.[0]}
            </div>
          </div>

          {/* Role */}
          <div className="mb-3">
            <label className="form-label">
              Select Role <span className="required" >*</span>
            </label>

            <select
              className={`form-select ${
                validate.validate?.roleId ? "is-invalid" : ""
              }`}
              value={roleId}
              onChange={(e) => setRoleId(e.target.value)}
            >
              <option value="">-- Select Role --</option>
              {roles.map((role) => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
            </select>

            <div className={`invalid-feedback d-block ${validate.validate?.roleId ? "" : "d-none"}`}>
              {validate.validate?.roleId?.[0]}
            </div>
          </div>

          {/* Department */}
          <div className="mb-3">
            <label className="form-label">
              Select Department <span className="required">*</span>
            </label>

            <select
              className={`form-select ${
                validate.validate?.departmentId ? "is-invalid" : ""
              }`}
              value={departmentId}
              onChange={(e) => setDepartmentId(e.target.value)}
            >
              <option value="">-- Select Department --</option>
              {departments.map((dept) => (
                <option key={dept.id} value={dept.id}>
                  {dept.name}
                </option>
              ))}
            </select>

            <div className={`invalid-feedback d-block ${validate.validate?.departmentId ? "" : "d-none"}`}>
              {validate.validate?.departmentId?.[0]}
            </div>
          </div>

          {/* Buttons */}
          <div className="form-footer d-flex gap-2">
            <button type="submit" className="btn btn-primary flex-grow-1">
              Submit
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary flex-grow-1"
              onClick={() => navigate("/login")}
            >
              Cancel
            </button>
          </div>

          <div className="text-center mt-3">
            <span className="text-muted">
              Already have an account?{" "}
              <Link to="/login" className="text-primary">
                Login here
              </Link>
            </span>
          </div>
        </form>
      </div>

      <div className="col-lg-5 offset-lg-1">
        <img
          className="img-fluid"
          src={process.env.PUBLIC_URL + "/assets/img/login/login.png"}
          alt="banner"
        />
      </div>
    </div>
  </div>
</section>

    </>
  );
}

export { Register };
